import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Row,
  Select,
  Upload,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "../Blog/coupon.css";
import { PlusOutlined } from "@ant-design/icons";
import { addBlog, editBlog, getBlogCategory } from "./BlogApi";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatchtoast } from "../../../utils";
import ComponentTitle from "../../../Common/ComponentTitle";
import ReactQuill from "react-quill";
import { MdUpload } from "react-icons/md";

function AddBlog() {
  const location = useLocation();
  const fill = location.state?.fill;
  const from = location.state?.from;
  const { Option } = Select;
  const [blogCategorydata, setblogCategoryData] = useState([]);
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [metaContent, setMetaContent] = useState("");
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const navigate = useNavigate();
  const MAX_FILE_SIZE_MB = 25;
  const [coverImg, setCoverImage] = useState(fill?.coverImage ?? null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [BlogCategoryTypes, setBlogCategoryTypes] = useState(
    from === "edit"
      ? fill?.categories?.map((i, id) => {
          return i.id;
        })
      : []
  );

  const generateSlug = (value) => {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const handleTitleChange = (e) => {
    const inputValue = e.target.value;
    const slugValue = generateSlug(inputValue);

    const updatedMetaTags = form.getFieldValue("metaTags") || [];
    if (updatedMetaTags.length > 0) {
      updatedMetaTags[0].description = inputValue;
    } else {
      updatedMetaTags.push({ keywords: "title", description: inputValue });
    }

    form.setFieldsValue({
      slug: slugValue,
      metaTags: updatedMetaTags,
    });

    setTitle(inputValue);
    setSlug(slugValue);
    setMetaContent(inputValue);
  };

  const initialValues = {
    title: fill.title,
    subtitle: fill.subtitle,
    slug: fill.slug,
    metaTags: fill.metaTags,
    image: fill.coverImage,
    blogCategoryId: fill.categories?.map((i) => i.id),
    description: fill.description,
  };

  const createBlog = (changedValues) => {
    const formData = new FormData();
    formData.append("title", changedValues.title);
    formData.append("subtitle", changedValues.subtitle);
    formData.append("slug", changedValues.slug);
    formData.append("metaTags", JSON.stringify(changedValues.metaTags));

    formData.append("description", changedValues.description);
    if (from === "edit") {
      formData.append("blogCategoryId", JSON.stringify(BlogCategoryTypes));
    } else {
      formData.append("blogCategoryIds", JSON.stringify(BlogCategoryTypes));
    }
    if (coverImg) {
      formData.append("image", coverImg);
    }
    {
      from === "edit"
        ? editBlog(formData, `${fill.id}`)
            .then((response) => {
              if (response.status) {
                navigate("/blog/previewBlog", {
                  state: {
                    id: response.data?.data?.id,
                  },
                });
                form.resetFields();
              } else {
                dispatchtoast("Fields can not be empty", true);
              }
            })
            .catch((error) => {
              console.log(error);
            })
        : addBlog(formData)
            .then((response) => {
              if (response.status) {
                navigate("/blog/previewBlog", {
                  state: {
                    id: response.data?.data?.id,
                  },
                });
                console.log(response.data, "adadadsj");
                form.resetFields();
              } else {
                dispatchtoast("Something went wrong", true);
              }
            })
            .catch((error) => {
              console.log(error);
            });
    }
  };
  const handleBlogChange = (val) => {
    setBlogCategoryTypes(val);
  };

  const FetchBlogCategoryData = () => {
    getBlogCategory()
      .then((response) => {
        if (response.data.status) {
          setblogCategoryData(response.data.data);
        }
      })
      .catch((err) => console.error("Error fetching data", err));
  };

  useEffect(() => {
    FetchBlogCategoryData();
  }, []);

  const metaTagOptions = [
    "description",
    "title",
    "keywords",
    "robots",
    "author",
  ];

  const props = {
    name: "file",
    accept: ".jpg,.jpeg,.png",
    multiple: false,
    beforeUpload: (file) => {
      const isLt25M = file.size / 1024 / 1024 < MAX_FILE_SIZE_MB;
      if (!isLt25M) {
        message.error(`File must be smaller than ${MAX_FILE_SIZE_MB}MB!`);
        return false;
      }

      setCoverImage(file);
      setPreviewUrl(URL.createObjectURL(file));
      return false; // prevent default upload
    },
  };

  const handleRemove = () => {
    setCoverImage(null);
  };

  const handleChange = ({ file }) => {
    if (file.status === "done" || file.originFileObj) {
      const url = URL.createObjectURL(file.originFileObj);
      setCoverImage({ url, name: file.name });
    }
  };
  useEffect(() => {
    return () => {
      if (coverImg?.url) {
        URL.revokeObjectURL(coverImg.url);
      }
    };
  }, [coverImg]);

  return (
    <div>
      <ComponentTitle
        title={from === "edit" ? "Edit Blog " : "Create Blog Form"}
      />
      <div className="bg-white box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px">
        {" "}
        <Form
          className=" mt-8 font-poppins font-medium text-xs  p-6"
          layout="vertical"
          onFinishFailed={(err) => console.log(err)}
          onFinish={createBlog}
          form={form}
          ref={formRef}
          initialValues={
            from === "edit"
              ? initialValues
              : {
                  metaTags: [{ keywords: "Title", description: "" }],
                }
          }
        >
          <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
            <Col>
              <Form.Item
                label={<p className="font-medium">Title</p>}
                name="title"
                rules={[
                  { required: true, message: "Please enter Title" },
                  { min: 4, message: "Title must be at least 4 characters" },
                ]}
              >
                <Input
                  placeholder="e.g., properties title here"
                  value={title}
                  onChange={handleTitleChange}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label={<p className="font-medium">SubTitle</p>}
                name="subtitle"
              >
                <Input placeholder="e.g., properties subtitle here" />
              </Form.Item>
            </Col>
          </Row>

          <Row className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Col>
              <Form.Item
                label={<p className="font-medium">Blog Category</p>}
                name="blogCategoryId"
                rules={[
                  { required: true, message: "Please select a category" },
                ]}
              >
                <Select
                  placeholder="e.g., Blog Category"
                  mode="multiple"
                  onChange={handleBlogChange}
                  options={blogCategorydata.map((i) => ({
                    label: i.blogCategoryName,
                    value: i.id,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label={<p className="font-medium">Slug</p>}
                name="slug"
                rules={[
                  { required: true, message: "Please enter Slug" },
                  { min: 6, message: "Slug must be at least 6 characters" },
                  {
                    pattern: /^[a-zA-Z0-9-]+$/,
                    message:
                      "Slug can only contain letters, numbers, and hyphens",
                  },
                ]}
              >
                <Input
                  placeholder="e.g.,title-slug-here"
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="grid grid-cols-1 gap-4">
            <p className="font-medium">Meta Tags</p>
            <Col>
              <Form.Item
                validateTrigger="onSubmit"
                style={{ marginBottom: "16px" }}
              >
                <Form.List
                  name="metaTags"
                  rules={[
                    {
                      validator: async (_, metaTags) => {
                        if (!metaTags || metaTags.length < 1) {
                          return Promise.reject(
                            new Error("Please add at least one tag")
                          );
                        }
                      },
                    },
                  ]}
                >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(
                        ({ key, name, fieldKey, ...restField }, index) => {
                          return (
                            <div
                              key={key}
                              style={{ marginBottom: "16px" }}
                              className="grid grid-cols-1 sm:grid-cols-[1%_47%_40%_8%] gap-4"
                            >
                              <p className="font-medium">{index + 1}•</p>

                              {/* Keywords Field */}
                              <Form.Item
                                {...restField}
                                name={[name, "keywords"]}
                                fieldKey={[fieldKey, "keywords"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select a meta tag name",
                                  },
                                ]}
                              >
                                {index === 0 ? (
                                  <Input value="title" disabled />
                                ) : (
                                  <Select placeholder="Select a tag">
                                    {metaTagOptions
                                      .slice(0, 5)
                                      .map((option) => (
                                        <Option key={option} value={option}>
                                          {option.charAt(0).toUpperCase() +
                                            option.slice(1)}
                                        </Option>
                                      ))}
                                  </Select>
                                )}
                              </Form.Item>

                              {/* Description Field */}
                              <Form.Item
                                {...restField}
                                name={[name, "description"]}
                                fieldKey={[fieldKey, "description"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Please enter meta tag description",
                                  },
                                ]}
                              >
                                <Input.TextArea
                                  placeholder="e.g., meta tag description here"
                                  value={index === 0 ? metaContent : undefined}
                                  onChange={
                                    index === 0
                                      ? (e) => setMetaContent(e.target.value)
                                      : undefined
                                  }
                                />
                              </Form.Item>

                              {/* Remove Button */}
                              <Button
                                onClick={() => remove(name)}
                                disabled={index === 0 || fields.length === 1}
                                className="bg-red-500 text-xs text-white border-none rounded-none"
                              >
                                Remove
                              </Button>
                            </div>
                          );
                        }
                      )}

                      <Form.Item>
                        <Button
                          className="rounded-none p-[0px_32px_0px_32px] text-white font-dmsans font-semibold bg-rgbaprimary9 text-xs"
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          Add Meta Tag
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1">
            <Col>
              <Form.Item
                name="description"
                label="
                 Description"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Description",
                  },
                ]}
              >
                <ReactQuill
                  theme="snow"
                  className="bg-white"
                  onChange={(value) =>
                    form.setFieldsValue({ description: value })
                  }
                  placeholder="Write your product description here..."
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="grid grid-cols-1 gap-4">
            <Col>
              <Form.Item name="image" label="Add Cover Image">
                <Upload
                  {...props}
                  listType="picture"
                  maxCount={1}
                  fileList={
                    coverImg
                      ? [
                          {
                            uid: "-1",
                            name: coverImg.name || "Cover Image",
                            url:
                              from === "edit"
                                ? `${process.env.REACT_APP_IMAGE_URL}${coverImg}`
                                : previewUrl,
                          },
                        ]
                      : []
                  }
                  onRemove={() => {
                    setCoverImage(null);
                    setPreviewUrl(null);
                  }}
                  showUploadList={{ showRemoveIcon: from !== "edit" }}
                >
                  {(!coverImg || from === "edit") && (
                    <Button icon={<MdUpload />}>Click to Upload</Button>
                  )}
                </Upload>

                {/* {from === "edit" && coverImg && (
                  <Image
                    src={`${process.env.REACT_APP_IMAGE_URL}${coverImg}`}
                    alt="Cover"
                    style={{ maxWidth: "100px", marginTop: "10px" }}
                  />
                )} */}
              </Form.Item>
            </Col>
          </Row>

          <Row className="flex justify-between">
            <Form.Item>
              <Button
                onClick={() => {
                  from === "edit"
                    ? navigate("/blog/blogData")
                    : form.resetFields();
                }}
                className="rounded-none p-[0px_32px_0px_32px]   text-sm font-dmsans font-semibold text-gray2 "
                size="small"
                htmlType="onSubmit"
              >
                Cancel
              </Button>
            </Form.Item>

            <Form.Item>
              <Button
                className="rounded-none p-[0px_32px_0px_32px]  text-white font-dmsans font-semibold  bg-rgbaprimary9 text-xs "
                size="small"
                htmlType="submit"
              >
                {from === "edit" ? "Edit" : "Create"} Blog
              </Button>
            </Form.Item>
          </Row>
        </Form>
      </div>
    </div>
  );
}

export default AddBlog;
